const $ = jQuery.noConflict();

'use strict';
const PropertyCards = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		if ($(window).width() > 1199) {
			this.scrollAnimation();
		}
		this.colorStatus();
	},

	colorStatus: function() {
		$('.js-property-status').each(function() {
			const status = $(this).text().trim();
			if (status === 'Live auction') {
				$(this).css({
					'background-color': '#E4F9DE',
					'color': '#3E8028'
				}).addClass('live-auction');
				$(this).parent().parent().addClass('live-auction');
			} else if (status === 'Open To Offers') {
				$(this).css({
					'background-color': '#E4F9DE',
					'color': '#3E8028'
				});
			} else if (status === 'Approved') {
				$(this).css({
					'background-color': '#E9FBCD',
					'color': '#62A000'
				}).addClass('approved-auction');
			} else if (status === 'Completed Auction') {
				$(this).css({
					'background-color': '#26411F',
					'color': '#FCFCFD'
				}).addClass('completed-auction');
				$(this).parent().parent().addClass('completed-auction');
			} else if (status === 'Finished') {
				$(this).css({
					'background-color': '#3D3D3D',
					'color': '#F2F8FD'
				}).addClass('finished-auction');
				$(this).parent().parent().addClass('finished-auction');
			} else if (status === 'Cooming Soon') {
				$(this).css({
					'background-color': '#DCDCDC',
					'color': '#3D3D3D'
				}).addClass('cooming-soon-auction');
				$(this).parent().parent().addClass('cooming-soon-auction');
			} else if (status === 'Upcoming Auction') {
				$(this).css({
					'background-color': '#EFF0F3',
					'color': '#62636C'
				}).addClass('upcoming-auction');
				$(this).parent().parent().addClass('upcoming-auction');
			} else if (status === 'In review') {
				$(this).css({
					'background-color': '#FFE6D4',
					'color': '#FC7A1E'
				}).addClass('in-review-auction');
				$(this).parent().parent().addClass('in-review-auction');
			} else if (status === 'Expired') {
				$(this).css({
					'background-color': '#FFDEDC',
					'color': '#C2160E'
				}).addClass('in-review-auction');
				$(this).parent().parent().addClass('in-review-auction');
			} else {
				$(this).css({
					'background-color': '#FFE6D4',
					'color': '#FC7A1E'
				}).addClass('no-auction');
			}
		});
	},

	scrollAnimation: function() {
		if ($('.hero').length) {
			$(window).on('scroll', function() {
				const scrollPosition = $(this).scrollTop();
				const translateYValue = -scrollPosition / 2 + 'px';
				$('.js-scroll-anim').css('transform', 'translateY(' + translateYValue + ')');
			});
		}
	}
};

export default PropertyCards;
